import { Text } from 'bold-ui'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import { formatImcParticipante } from 'view/atividade-coletiva/utils-atividadeColetiva'

interface ParticipanteImcProps {
  participante: ParticipanteModel
}

export const ParticipanteImc = ({ participante }: ParticipanteImcProps) => {
  const imc = formatImcParticipante(participante)

  return imc ? <Text>{imc}</Text> : <>-</>
}
